// Maps each Cangjie radical glyph to its letter code (24 radicals; X = special).
// The keyboard emits glyphs, the dictionary is keyed by letter codes, so this is
// the lookup needed to turn a typed buffer (e.g. 竹手戈) into a code (e.g. "hqi").
export const CANGJIE_RADICAL_CODES: Record<string, string> = {
  '日': 'a', '月': 'b', '金': 'c', '木': 'd', '水': 'e', '火': 'f', '土': 'g',
  '竹': 'h', '戈': 'i', '十': 'j', '大': 'k', '中': 'l', '一': 'm', '弓': 'n',
  '人': 'o', '心': 'p', '手': 'q', '口': 'r', '尸': 's', '廿': 't', '山': 'u',
  '女': 'v', '田': 'w', '難': 'x', '卜': 'y',
};

export const isCangjieRadical = (glyph: string): boolean => glyph in CANGJIE_RADICAL_CODES;